/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import ParticipantGroup from './participant_group'
import Collection from './collection'
import _ from 'underscore'

// @namespace Model
export default class ParticipantGroups extends Collection {
  get model () { return ParticipantGroup }

  url () {
    return '/api/participant_groups'
  }

  /*
   * return a boolean of whether a collection
   * of participant groups matched any on this
   * collection that are checked
   */
  anyMatchChecked (groups) {
    const participantIds = groups.pluck('id')

    // Add ungrouped if the participant isn't in any groups
    if (!participantIds.length) { participantIds.push(0) }

    return _.intersection(this.checkedIds(), participantIds).length > 0 // force boolean
  }

  onlyUngrouped () {
    return this.all(group => group.isUngrouped())
  }

  lastId () {
    const maxItem = this.max(item => item.id)

    return (maxItem != null ? maxItem.id : undefined) || 1
  }

  checked () {
    return this.where({ checked: true })
  }

  allChecked () {
    return this.checked().length === this.length
  }

  checkedIds () {
    return _.pluck(this.checked(), 'id')
  }

  anyChecked () {
    return this.checked().length > 0
  }

  /*
   * find the next group in
   * the collection if it exists
   */
  next (group) {
    const currentIndex = this.indexOf(group)

    return this.at(currentIndex + 1)
  }

  /*
   * find the previous group in
   * the collection if it exists
   */
  previous (group) {
    const currentIndex = this.indexOf(group)

    if (currentIndex === 0) { return }

    return this.at(currentIndex - 1)
  }
}
